import { createFileRoute } from '@tanstack/react-router';
import { DocsHubPage } from '@/features/docs/hub/docs-hub-page';

export const Route = createFileRoute('/w/$workspaceId/docs/')({ component: DocsHubPage });
